import { render } from "./navComponent.vue?vue&type=template&id=5293cec1&scoped=true"
import script from "./navComponent.vue?vue&type=script&lang=js"
export * from "./navComponent.vue?vue&type=script&lang=js"

import "./navComponent.vue?vue&type=style&index=0&id=5293cec1&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5293cec1"]])

export default __exports__